import { LabelsMap } from 'new/form/common/types';

import { contractLaneSectionLabelsMap } from './sections/contractLane/labels';

export const offerPageLabelsMap: LabelsMap = {
  ...contractLaneSectionLabelsMap,
};
